import componentShell from "./shell"
import Frontpage from "@/frontpage"

export default componentShell(Frontpage)
